export default [
  'adPlay',
  'adPause',
  'pause',
  'firstFrame',
  'play',
  'time',
  'complete',
  'fullscreen',
  'adStarted',
  'adComplete',
  'adViewableImpression',
  'adClick',
  'adSkipped',
  'adRequest',
  'adError',
];
